export const SL_V2_OFFER_COLS_KEY = 'sl-v2-offer-table-cols'

export const OFFER_TABLE_COLS = [
  { k: 'id', l: 'ID', on: true },
  { k: 'affise', l: 'Affise ID', on: true },
  { k: 'goId', l: 'Global Offer ID', on: true },
  { k: 'vta', l: 'VTA', on: true },
  { k: 'nm', l: 'Name', on: true },
  { k: 'comments', l: 'Comments', on: false },
  { k: 'bundles', l: 'Bundles list', on: true },
  { k: 'conn', l: 'Conn type', on: true },
  { k: 'weight', l: 'Weight', on: true },
  { k: 'autoWeight', l: 'Auto Weight', on: true },
  { k: 'cap', l: 'Click Cap', on: true },
  { k: 'freq', l: 'Frq', on: true },
  { k: 'ipfreq', l: 'IP Frq', on: true },
  { k: 'dfreq', l: 'D Frq', on: true },
  { k: 'subs', l: 'Subs BL/WL', on: true },
  { k: 'status', l: 'Status', on: true }
]

export function defaultOfferCols() {
  const out = {}
  OFFER_TABLE_COLS.forEach(c => { out[c.k] = c.on })
  return out
}

function mergeOfferCols(stored) {
  const out = defaultOfferCols()
  if (!stored || typeof stored !== 'object') return { cols: out, changed: true }
  let changed = false
  OFFER_TABLE_COLS.forEach(c => {
    if (typeof stored[c.k] === 'boolean') {
      out[c.k] = stored[c.k]
    } else {
      changed = true
    }
  })
  return { cols: out, changed: changed || Object.keys(stored).length !== OFFER_TABLE_COLS.length }
}

export function loadOfferCols() {
  const defaults = defaultOfferCols()
  try {
    const raw = localStorage.getItem(SL_V2_OFFER_COLS_KEY)
    if (!raw) {
      localStorage.setItem(SL_V2_OFFER_COLS_KEY, JSON.stringify(defaults))
      return defaults
    }
    const parsed = JSON.parse(raw)
    const merged = mergeOfferCols(parsed)
    if (merged.changed) {
      localStorage.setItem(SL_V2_OFFER_COLS_KEY, JSON.stringify(merged.cols))
    }
    return merged.cols
  } catch (e) {
    try {
      localStorage.setItem(SL_V2_OFFER_COLS_KEY, JSON.stringify(defaults))
    } catch (err) {}
    return defaults
  }
}

export function saveOfferCols(cols) {
  try {
    localStorage.setItem(SL_V2_OFFER_COLS_KEY, JSON.stringify(cols))
  } catch (e) {}
}
